import userReducers from "./userReducers";
import serviceReducers from "./serviceReducers";

const rootReducer = {
    user: userReducers, 
    services: serviceReducers, 
};

export default rootReducer;